// removed by extract-text-webpack-plugin
module.exports = {"base":"Checkbox_base--3L0bN","isDisabled":"Checkbox_isDisabled--Okn9u","hasCaption":"Checkbox_hasCaption--EpgWb","base__big":"Checkbox_base__big--2ECJt","baseBig":"Checkbox_base__big--2ECJt","input":"Checkbox_input--34YCl","check":"Checkbox_check--3heDj","isChecked":"Checkbox_isChecked--eUuwT","caption":"Checkbox_caption--36vPk"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Checkbox/Checkbox.css
// module id = 1765
// module chunks = 16